<template>
    <div>
      <el-row style="margin-bottom: 20px">
        <el-col>
          快递公司：<el-input v-model="kdName" size="mini" class="text"></el-input> 模板名称：<el-input v-model="tmpName" size="mini" class="text"></el-input> <el-button  type="primary" >查询</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 20px">
        <el-col>
          <el-button  type="primary" >添加新模板</el-button>
        </el-col>
      </el-row>
    </div>
</template>

<script>
    export default {
        name: "PrintMd",
      data(){
         return{
           // 顽皮打印 https://help.ashiyue.com/?p=55
           // 云打印对接知识库 https://support-cnkuaidi.taobao.com/doc.htm#?docId=108595&docType=1
           // 易掌柜 https://www.shuaishou.com/help/4124.html
           // 知识库 https://open.taobao.com/docs/doc.htm?spm=a219a.15212433.0.0.2535669a36r01j&docType=1&articleId=105086&treeId=17&platformId=17#6
           // 测试 http://cdn-cloudprint.cainiao.com/waybill-print/docs/test/test_print.html
           //知识库 https://support-cnkuaidi.taobao.com/docs/doc.htm?treeId=493&articleId=108190&docType=1
           //模板迁移 https://support-cnkuaidi.taobao.com/docs/doc.htm?spm=a21da.7629140.0.0.wpWxSV&treeId=409&articleId=107070&docType=1
           //Top接口 https://support-cnkuaidi.taobao.com/docs/doc.htm?treeId=409&articleId=107069&docType=1
           // 我打 知识库 https://www.yuque.com/woda/taobao/dfleqg
           //自定义区 https://blog.csdn.net/gong0585/article/details/53424355

           kdName:'',
           tmpName:'',
         }
      },
      methods:{
        gotoDesign:function(){
          this.$router.replace({name: 'Design'})
        },
        connect:function(){
          let  serverUrl='ws://localhost:13528';
          if(typeof(WebSocket) === "undefined"){
            alert("您的浏览器不支持socket")
          }else{
            // 实例化socket
            this.socket = new WebSocket(serverUrl);
            // 监听socket连接
            this.socket.onopen = this.open;
            // 监听socket错误信息
            this.socket.onerror = this.error;
            // 监听socket消息
            this.socket.onmessage = this.getMessage;
          }
        },
        open: function () {
          console.log("socket连接成功");
          this.getPrint();
        },
        error: function () {
          console.log("连接错误")
        },
        getMessage: function (obj) {
          console.log(obj.data);
          let data = JSON.parse(obj.data);
          if (data.cmd == "getPrinters") {
            this.printerList = data.printers;
            this.printName = data.defaultPrinter;
          }else if (data.cmd == "getPrinterConfig") {
            alert(obj.data);
          }
          if (data.previewImage) {
            this.imgUrl = data.previewImage;
            this.showPreview=true;
          }
        },
        send: function () {
          this.socket.send(params)
        },
        close: function () {
          console.log("socket已经关闭")
        },
        getRequestObject: function (cmd) {
          let request = new Object();
          let time = new Date().getTime();
          request.requestID=time.toString();
          request.version="1.0";
          request.cmd=cmd;
          return request;
        },

        getPrint: function () {
          let request = this.getRequestObject("getPrinters");
          this.socket.send(JSON.stringify(request));
        },
        getConfig: function () {
          let request = this.getRequestObject("getPrinterConfig");
          console.log(this.printName);
          request.printer = this.printName;
          this.socket.send(JSON.stringify(request));
        },
        print:function (value) {
          let request = this.getRequestObject("print");
          request.task = new Object();
          request.task.taskID = request.requestID + "_TASK_0";
          if (value == "preview") {
            request.task.preview = true;
            request.task.previewType = "image";
          } else {
            request.task.preview = false;
          }
          request.task.printer = this.printName;
          let documents = new Array();
          //const selectData = this.$refs.multipleTable.selection;
          //console.log(selectData.length);
          //for(let i=0;i<selectData.length;i++){
          for(let i=0;i<1;i++){
            let row = selectData[i];
            console.log(row);

            let doc = new Object();
            doc.documentID = i;
            let contents = new Array();
            let content = new Object();
            content.templateURL = "http://cloudprint.cainiao.com/template/standard/300224/17";
            let trade = new Object();

            content.data = trade;
            contents.push(content);
            doc.contents = contents;
            documents.push(doc);
            if (value == "preview")
              break;
          }
          request.task.documents = documents;
          console.log(JSON.stringify(request))
          this.socket.send(JSON.stringify(request));
        },
        //生成测试数据
        getTempTestObject: function () {
          let trade = new Object();
        }
      },
      mounted() {

      }
    }
</script>

<style scoped>
  .text{
    width: 120px;
  }

</style>



// WEBPACK FOOTER //
// src/print/PrintMd.vue